import { getAllPendingOrders, rejectOrders, processApprovedOrders } from "../../api/orders";

const orders = {
  namespaced: true,
  state: () => ({
    status: {
      items: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    items: [],
  }),
  getters: {},
  actions: {
    fetchAllPendingOrders({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_REFRESHING_TRUE", "items");
        commit("SET_ERROR_FALSE", "items");

        getAllPendingOrders(
          data.searchUserOrderId,
          data.pageNumber,
          data.pageSize,
          data.sortField,
          data.sortOrder
        )
          .then((items) => {
            commit("SET_INITIALIZED_TRUE", "items");
            commit("SET_REFRESHING_FALSE", "items");
            commit("SET_ITEMS", items);
            resolve();
          })
          .catch((err) => {
            commit("SET_REFRESHING_FALSE", "items");
            commit("SET_ERROR_TRUE", "items");
            reject(err);
          });
      });
    },
    removeOrders({ commit }, data) {
      return new Promise((resolve, reject) => {
        rejectOrders(data)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    approveOrders({ commit }, data) {
      return new Promise((resolve, reject) => {
        processApprovedOrders(data)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true;
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true;
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false;
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true;
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false;
    },
    SET_ITEMS: (state, payload) => {
      state.items = payload;
    },
  },
};

export default orders;
